import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function CollegeStandardFeesReference({
  displayFees,
  title = "College / institution standard fees — for reference only",
}) {
  if (!displayFees?.feePerSem && !displayFees?.totalFees) {
    return null;
  }

  const items = [
    { label: "Fee / term", value: displayFees.feePerSem || "—" },
    {
      label: "Scholarship",
      value: displayFees.scholarship ? `${displayFees.scholarship}%` : "—",
    },
    { label: "No. of terms", value: displayFees.noOfSem || "—" },
    { label: "Total fees", value: displayFees.totalFees || "—" },
  ];

  return (
    <Box
      sx={(theme) => ({
        p: 2,
        bgcolor: alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.2 : 0.1),
        border: "1px solid",
        borderColor: alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.45 : 0.35),
        borderRadius: 2,
      })}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: "info.main", display: "block", mb: 1.5 }}
      >
        {title}
      </Typography>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {items.map(({ label, value }) => (
          <div key={label}>
            <Typography variant="caption" color="text.secondary" display="block">
              {label}
            </Typography>
            <Typography variant="body2" fontWeight={600} color="text.primary">
              {value}
            </Typography>
          </div>
        ))}
      </div>
    </Box>
  );
}
